import React, { useRef, useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom"; // <-- Import yeh line zaroori hai
import DynamicHeader from "../Header/DynamicHeader";
import { showApiErrors } from "../utils";
import apis from "../services";

function Verification() {
  const [otp, setOtp] = useState(["", "", "", ""]);
  const [timer, setTimer] = useState(39);
  const [isResendEnabled, setIsResendEnabled] = useState(false);
  const inputRefs = useRef([null, null, null, null]);
  const navigate = useNavigate(); // <-- Hook yahan bhi
  const { email } = useLocation().state || {};
  

  console.log(email, "Verification"); 

  useEffect(() => {
    if (!email) {
      navigate('/forgot-password', { replace: true });
    }
  }, [email, navigate]);

  useEffect(() => {
    let interval;
    if (timer > 0) {
      interval = setInterval(() => setTimer(t => t - 1), 1000);
    } else {
      setIsResendEnabled(true);
    }
    return () => clearInterval(interval);
  }, [timer]);

  const handleChange = (index, value) => {
    if (!/^\d*$/.test(value)) return;
    const newOtp = [...otp];
    newOtp[index] = value.slice(-1);
    setOtp(newOtp);
    if (value && index < 3) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  const handleResend = async () => {
    setOtp(["", "", "", ""]);
    setTimer(39);
    setIsResendEnabled(false);
    try {
      const res = await apis.authRequestOtp({ email });
      console.log(res, "---");
   
    } catch (error) {
      showApiErrors(error, 'Something went wrong, please try again');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {

       let deviceId = localStorage.getItem('deviceId');
      console.log("first", deviceId)
    if (!deviceId) {
      deviceId = crypto.randomUUID();
      localStorage.setItem('deviceId', deviceId);
            console.log("second", deviceId)
    }

      if (otp.join("").length === 4) {
        const res = await apis.authVerifyOtp({ email,deviceId, otp: otp.join("") });
        console.log(res, "---");
        navigate('/change-password', { state: { email, otp: res?.data?.otp }, replace: true });
      }
    } catch (error) {
      showApiErrors(error, 'Something went wrong, please try again');
    }

  };

  return (
    <div className="login-background">
      <div className="header-container">
        <div className="header-content">
          <h2 className="header-subtitle">
            <span className="color-sp-lookna">Lookna</span>
            <br /><br />
            FIND YOUR<span className="color-sp"> IDEAL INVESTMENT </span>VAULT
          </h2>
        </div>
        <div className="details-borders"></div>
      </div>
      {/* <DynamicHeader/> */}
      <div style={{ height: "60px" }}></div>
      <div className="login-box">
        <h2 className="login-title" style={{ textAlign: "center", marginBottom: 8 }}>
          VERIFICATION
        </h2>
        <div style={{ textAlign: "center", color: "#c1c4d2", fontWeight: 400, marginBottom: 26 }}>
          Enter Your 4 Digits Code That You Received On Your Email.
        </div>
        <form onSubmit={handleSubmit}>
          <div className="otp-inputs">
            {otp.map((d, i) => (
              <input
                key={i}
                ref={el => (inputRefs.current[i] = el)}
                type="text"
                maxLength={1}
                className="otp-box"
                value={d}
                onChange={e => handleChange(i, e.target.value)}
                onKeyDown={e => handleKeyDown(i, e)}
                inputMode="numeric"
                autoComplete="one-time-code"
              />
            ))}
          </div>
          {/* <div style={{ textAlign: "center", color: "#aaa", margin: "15px 0 7px 0", fontWeight: 500, fontSize: 16 }}>
            00:{timer < 10 ? `0${timer}` : timer}
          </div> */}
          <button
            className="login-btn"
            type="submit"
            disabled={otp.some(val => val === "")}
            style={{
              marginTop: 10,
              marginBottom: 10,
              cursor: otp.some(val => val === "") ? "not-allowed" : "pointer"
            }}
          >
            Continue
          </button>
        </form>
        <div style={{ textAlign: "center", color: "#c1c4d2", marginTop: 8, display: "flex", alignItems: "center", justifyContent: "center", gap: 4 }}>
          Didn't Receive Code?
          {
            !isResendEnabled ? (
              <div style={{ color: "#aaa", fontWeight: 500, fontSize: 16 }}>
                00:{timer < 10 ? `0${timer}` : timer}
              </div>
            ) : (
              <span
                className="resend-link"
                onClick={isResendEnabled ? handleResend : undefined}
                style={{
                  color: isResendEnabled ? "#fff" : "#b3b3b3",
                  fontWeight: 700,
                  marginLeft: 7,
                  cursor: isResendEnabled ? "pointer" : "not-allowed",
                  textDecoration: isResendEnabled ? "underline" : "none"
                }}
              >
                Resend OTP
              </span>
            )
          }

        </div>
      </div>
    </div>
  );
}

export default Verification;





// import React, { useRef, useState, useEffect } from "react";

// function Verification() {
//   const [otp, setOtp] = useState(["", "", "", ""]);
//   const [timer, setTimer] = useState(39); // Start from 39 seconds
//   const [isResendEnabled, setIsResendEnabled] = useState(false);
//   const inputRefs = useRef([null, null, null, null]);

//   useEffect(() => {
//     let interval;
//     if (timer > 0) {
//       interval = setInterval(() => setTimer(t => t - 1), 1000);
//     } else {
//       setIsResendEnabled(true);
//     }
//     return () => clearInterval(interval);
//   }, [timer]);

//   const handleChange = (index, value) => {
//     if (!/^\d*$/.test(value)) return; // Only digits allowed
//     const newOtp = [...otp];
//     newOtp[index] = value.slice(-1); // Only last digit
//     setOtp(newOtp);
//     // Focus next input if available
//     if (value && index < 3) {
//       inputRefs.current[index + 1].focus();
//     }
//   };

//   const handleKeyDown = (index, e) => {
//     if (e.key === "Backspace" && !otp[index] && index > 0) {
//       inputRefs.current[index - 1].focus();
//     }
//   };

//   const handleResend = () => {
//     setOtp(["", "", "", ""]);
//     setTimer(39);
//     setIsResendEnabled(false);
//     // Here you can call your resend OTP API
//   };

//   const handleSubmit = e => {
//     e.preventDefault();
//     if (otp.join("").length === 4) {
//       // Call verify API here with otp.join("")
//       alert("OTP Verified: " + otp.join(""));
//     }
//   };

//   return (
//     <div className="login-background">
//        <div className="header-container">
//         <div className="header-content">
//           <h2 className="header-subtitle">
//             <span className="color-sp-lookna">Lookna</span>
//             <br /><br />
//             FIND YOUR<span className="color-sp"> IDEAL INVESTMENT </span>VAULT
//           </h2>
//         </div>
//         <div className="details-borders"></div>
//       </div>
//        <div style={{ height: "60px" }}></div> {/* Spacing for header */}
//       <div className="login-box">
//         <h2 className="login-title" style={{ textAlign: "center", marginBottom: 8 }}>
//           VERIFICATION
//         </h2>
//         <div style={{ textAlign: "center", color: "#c1c4d2", fontWeight: 400, marginBottom: 26 }}>
//           Enter Your 4 Digits Code That You Received On Your Email.
//         </div>
//         <form onSubmit={handleSubmit}>
//           <div className="otp-inputs">
//             {otp.map((d, i) => (
//               <input
//                 key={i}
//                 ref={el => (inputRefs.current[i] = el)}
//                 type="text"
//                 maxLength={1}
//                 className="otp-box"
//                 value={d}
//                 onChange={e => handleChange(i, e.target.value)}
//                 onKeyDown={e => handleKeyDown(i, e)}
//                 inputMode="numeric"
//                 autoComplete="one-time-code"
//               />
//             ))}
//           </div>
//           <div style={{ textAlign: "center", color: "#aaa", margin: "15px 0 7px 0", fontWeight: 500, fontSize: 16 }}>
//             00:{timer < 10 ? `0${timer}` : timer}
//           </div>
//           <button
//             className="login-btn"
//             type="submit"
//             disabled={otp.some(val => val === "")}
//             style={{
//               marginTop: 10,
//               marginBottom: 10,
//               cursor: otp.some(val => val === "") ? "not-allowed" : "pointer"
//             }}
//           >
//             Continue
//           </button>
//         </form>
//         <div style={{ textAlign: "center", color: "#c1c4d2", marginTop: 8 }}>
//           Didn't Receive Code?
//           <span
//             className="resend-link"
//             onClick={isResendEnabled ? handleResend : undefined}
//             style={{
//               color: isResendEnabled ? "#fff" : "#b3b3b3",
//               fontWeight: 700,
//               marginLeft: 7,
//               cursor: isResendEnabled ? "pointer" : "not-allowed",
//               textDecoration: isResendEnabled ? "underline" : "none"
//             }}
//           >
//             Resend OTP
//           </span>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default Verification;
